const PreferenceKeys = {
    accessToken: 'lsp_admin_token',
    accessTokenExpired: 'lsp_admin_token_expired',
};

export default PreferenceKeys;